import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BoothDesign from './boothDesign';
import BoothCMSTemplate from './templates';

const BoothTemplateSwitch = ({
  booth,
  handleClick,
  isPreview,
}) => {
  const isV2Design = useMemo(() => !!booth.boothDesign?.id, [booth.boothDesign?.id]);

  return (
    <>
      {
        isV2Design ? (
          <BoothDesign
            boothId={booth.id}
            isPreview={isPreview}
          />
        ) : (
          <BoothCMSTemplate
            booth={booth}
            handleClick={handleClick}
            isPreview={isPreview}
          />
        )
      }
    </>
  );
};

BoothTemplateSwitch.propTypes = {
  booth: PropTypes.shape().isRequired,
  handleClick: PropTypes.func,
  isPreview: PropTypes.bool,
};

BoothTemplateSwitch.defaultProps = {
  handleClick: () => { },
  isPreview: false,
};

export default BoothTemplateSwitch;
